import './setupResizeObserver'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import App from './App'
import { store, persistor } from './redux/store'
import * as serviceWorker from './serviceWorker'
import TagManager from 'react-gtm-module'
import { REACT_GOOGLE_TAG_MANAGER } from 'private/config'
import './styleLess/CommonStyle.scss'
import './styleLess/button.scss'
import './styleLess/ItemBox.scss'
import './styleLess/Layout.scss'
import './styleLess/icons.scss'
import './styleLess/input.scss'

const tagManagerArgs = { gtmId: REACT_GOOGLE_TAG_MANAGER }
TagManager.initialize(tagManagerArgs)


ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
